class sizeGuide extends HTMLElement {
    constructor() {
        super();
        this.openModalButtons = this.querySelectorAll('.js-open-modal');
        this.closeModalButtons = this.querySelectorAll('.js-close-modal');
        this.convertButtons = this.querySelectorAll('.js-unit-toggle-label')
        this.sizeGuideContentModal = this.querySelector('.size-guide__modal')
    }

    connectedCallback() {
        this.openModalButtons.forEach(function(openModalButton) {
            openModalButton.addEventListener('click', this.initOpen.bind(this));
        }.bind(this));

        this.closeModalButtons.forEach(function(closeModalButton) { 
            closeModalButton.addEventListener('click', this.initClose.bind(this));
        }.bind(this));

        this.convertButtons.forEach(function(convertButton) {
            convertButton.addEventListener('click', this.convertUnit.bind(this, convertButton));
            if(convertButton.classList.contains('is-active') && convertButton.textContent == 'cm') {
                convertButton.previousElementSibling.click();
            }

        }.bind(this));
    }

    initOpen(e) {
        e.preventDefault();
        this.sizeGuideContentModal.classList.add('is-active');
        document.body.classList.add('overflow-hidden');
        document.body.classList.add('open-size-chart');
    }

    initClose(e) { 
        this.sizeGuideContentModal.classList.remove('is-active'); 
        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('open-size-chart');
    }

    convertUnit($this) {
        let sizeTable = $this.parentElement.parentElement.parentElement;
        let valuesString = sizeTable.querySelectorAll('.size-guide__table-cell:not(.size-guide__table-header-cell)');
        let ratio = 0;
        sizeTable.querySelectorAll('.js-unit-toggle-label').forEach(function(el) {
            el.classList.remove('is-active');
        });

        if($this.textContent == 'cm') {
            $this.classList.add('is-active');
            valuesString.forEach(function(valueString) {
                let valueNumber = Number(valueString.textContent.replace('"',''))
                ratio = 2.54;
                if(isNaN(valueNumber) != true) {
                    valueString.innerText = `${Math.round(valueNumber * ratio * 10) / 10}cm`;
                }
            });
        } else if($this.textContent == 'inches') {
            $this.classList.add('is-active');
            valuesString.forEach(function(valueString) {
                let valueNumber = Number(valueString.textContent.replace('cm',''))
                ratio = 1/2.54;
                if(isNaN(valueNumber) != true) {
                    valueString.innerText = `${Math.round(valueNumber * ratio * 10) / 10}"`;
                }
            });
        }
    }
}
  
customElements.define('size-guide', sizeGuide);